
import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { GoMaterialModule } from '@go-modules/go-material.module';
import { UserSearchDialogModule } from '@go-modules/components/dialogs/user-search-dialog/user-search-dialog.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SuperBarComponent } from './super-bar.component';
import { OrgPickerModule } from '@go-modules/components/org-picker/org-picker.module';
import { FolderMenuModule } from '@go-modules/components/menus/folder-menu/folder-menu.module';
import { MenuButtonModule } from '@go-modules/components/menus/menu-button/menu-button.module';
import { AccountMenuModule } from '@go-modules/components/menus/account-menu/account-menu.module';
import { OrgMenuModule } from '@go-modules/components/menus/org-menu/org-menu.module';

@NgModule({
	imports: [
		CommonModule,
		TranslateModule,
		GoMaterialModule,
		FormsModule,
		ReactiveFormsModule,
		OrgPickerModule,
		FolderMenuModule,
		AccountMenuModule,
		OrgMenuModule,
		MenuButtonModule,
		UserSearchDialogModule
	],
	declarations: [
		SuperBarComponent
	],
	exports: [
		SuperBarComponent
	]
})
export class SuperBarModule {}
